/* eslint-disable */
import Vue from "vue";
import ShardsVue from "shards-vue";
import DataTable from "laravel-vue-datatable";
import VueSimpleAlert from "vue-simple-alert";

// Styles
import "bootstrap/dist/css/bootstrap.css";
import "datatables.net-bs4";
import "datatables.net-bs4/css/dataTables.bootstrap4.css";
import "jszip";
import "pdfmake";
import "datatables.net-buttons-bs4/js/buttons.bootstrap4";
import "datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css";
import "datatables.net-buttons/js/buttons.colVis";
import "datatables.net-buttons/js/buttons.flash";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons/js/buttons.print";
import "@/scss/shards-dashboards.scss";
import "@/assets/scss/date-range.scss";

// Core
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import Router from 'vue-router';
Vue.prototype.$axios = axios;
//配置请求的根路径
axios.defaults.baseURL = "/api";
// Layouts
ShardsVue.install(Vue);
Vue.use(DataTable);
Vue.use(VueSimpleAlert);
//全局变量
Vue.prototype.checknavbarclose = true;
Vue.prototype.navbarwidth = 0 + "px";

const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router);

import Default from "@/layouts/Default.vue";
Vue.component("default-layout", Default);

import Login from "@/views/Login.vue"
Vue.component("login-layout", Login);

Vue.config.productionTip = false;
Vue.prototype.$eventHub = new Vue();
Vue.prototype.authorization = new Vue({
  data: function() {
    return {
      token: null,
      refreshToken: null
    };
  }
});


new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
